const PATH = "M0 60 C 240 20 480 20 720 60 S 1200 100 1440 60 S 1920 20 2160 60 S 2640 100 2880 60 V100 H0Z";

export const Wave = ({ fill, top = false }) => (
  <div className={`pointer-events-none absolute inset-x-0 z-[1] h-14 overflow-hidden md:h-24 ${top ? "top-0 rotate-180" : "bottom-0"}`} aria-hidden="true">
    <svg className="wave-move-slow absolute bottom-0 h-full w-[200%] opacity-50" viewBox="0 0 2880 100" preserveAspectRatio="none">
      <path fill={fill} d={PATH} />
    </svg>
    <svg className="wave-move absolute bottom-0 h-[80%] w-[200%]" viewBox="0 0 2880 100" preserveAspectRatio="none">
      <path fill={fill} d={PATH} />
    </svg>
  </div>
);
